import React from 'react';
import { timeline } from '../mock';

export default function TimelineSection() {
  return (
    <section className="section" style={{ background: 'var(--sm-cream)' }}>
      <div className="container-x">
        <div style={{ textAlign: 'center', maxWidth: 760, margin: '0 auto 72px' }}>
          <div style={{ display: 'inline-flex', alignItems: 'center', gap: 14, marginBottom: 20 }}>
            <span className="hairline" />
            <span className="overline">The Journey</span>
            <span className="hairline" />
          </div>
          <h2 className="serif" style={{ fontSize: 'clamp(32px, 4vw, 52px)', lineHeight: 1.1, color: 'var(--sm-navy)', margin: 0 }}>
            From Caracas curiosity to a New York platform.
          </h2>
        </div>

        <div style={{ position: 'relative', maxWidth: 900, margin: '0 auto' }}>
          <div style={{ position: 'absolute', left: 118, top: 12, bottom: 12, width: 1, background: 'var(--sm-line)' }} className="tl-line" />
          {timeline.map((t) => (
            <div key={`${t.year}-${t.title}`} style={{ display: 'grid', gridTemplateColumns: '120px 24px 1fr', gap: 24, alignItems: 'start', paddingBottom: 56 }} className="tl-row">
              <div style={{ textAlign: 'right' }}>
                <div className="serif" style={{ fontSize: 22, color: 'var(--sm-navy)' }}>{t.year}</div>
              </div>
              <div style={{ position: 'relative', display: 'flex', justifyContent: 'center', paddingTop: 8 }}>
                <div style={{ width: 11, height: 11, borderRadius: '50%', background: 'var(--sm-gold)', border: '3px solid var(--sm-cream)', boxShadow: '0 0 0 1px var(--sm-gold)' }} />
              </div>
              <div>
                <div className="serif" style={{ fontSize: 22, color: 'var(--sm-navy)', marginBottom: 8 }}>{t.title}</div>
                <p style={{ fontSize: 15, lineHeight: 1.75, color: 'var(--sm-muted)', margin: 0, maxWidth: 560 }}>{t.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>

      <style>{`
        @media (max-width: 700px) {
          .tl-line { left: 6px !important; }
          .tl-row { grid-template-columns: 24px 1fr !important; }
          .tl-row > div:first-child { display: none; }
        }
      `}</style>
    </section>
  );
}
